import Layout from "../../components/Layout/Layout";
import StatsList from "../../components/CDP/Registrations/StatsList";
import StatsList2 from "../../components/CDP/Registrations/StatsList2";
import CustomerTable from "../../components/CDP/Registrations/CustomerTable";
import { useCdpFilters } from "./hooks/useCdpFilters";
import CdpFilterBar from "./components/CdpFilterBar";
import CdpSubNav from "./components/CdpSubNav";

export default function Registrations() {
  const {
    filters,
    dateValue,
    appliedFilters,
    handleApply,
    handleDateSelect,
    setDomain,
    setPlatform,
  } = useCdpFilters({ applyOnFieldChange: true });

  return (
    <Layout>
      <main>
        <div className="mx-auto my-6 max-w-7xl px-4 lg:px-0">
          <CdpSubNav />
          <div className="rounded-2xl bg-white text-gray-50 shadow-lg">
            <dl className="grid grid-cols-1 lg:grid-cols-3">
              <StatsList />
            </dl>
          </div>
        </div>

        <div className="mx-auto my-6 max-w-7xl px-4 lg:px-0">
          <div className="rounded-2xl bg-white text-gray-50 shadow-lg">
            <CdpFilterBar
              title="Registered User"
              domain={filters.domain}
              platform={filters.platform}
              dateValue={dateValue}
              onDomainChange={setDomain}
              onPlatformChange={setPlatform}
              onDateSelect={handleDateSelect}
              onApply={handleApply}
            />
            <dl className="grid grid-cols-1 lg:grid-cols-3">
              {appliedFilters?.product_id ? <StatsList2 selectedFilters={appliedFilters} /> : null}
            </dl>
          </div>
        </div>

        <div className="mx-auto my-6 max-w-7xl px-4 lg:px-0">
          <div className="rounded-2xl bg-white text-gray-50 shadow-lg">
            <CustomerTable selectedFilters={appliedFilters} />
          </div>
        </div>
      </main>
    </Layout>
  );
}
